export default __webpack_public_path__ + "static/media/search-input-icon.6c2e27a7.svg";